import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import { StyledCol, StyledRow } from './Grid.styles.js';
import neutral from '../../themes/neutral/index.js';

var _excluded = ["withMargin"];
var RowWithMargin = styled.div.withConfig({
  displayName: "Grid__RowWithMargin",
  componentId: "sc-g8dcaf-0"
})(["margin:0 ", ";@media (min-width:", "){margin:0 ", ";}"], neutral.spacings.medium, neutral.breakpoints.tablet, neutral.spacings.small);
var Row = function Row(_ref) {
  var withMargin = _ref.withMargin,
      rest = _objectWithoutProperties(_ref, _excluded);

  var row = /*#__PURE__*/React__default.createElement(StyledRow, rest);
  return withMargin ? /*#__PURE__*/React__default.createElement(RowWithMargin, null, row) : row;
};
Row.defaultProps = {
  'data-test-id': 'Row',
  gutter: [8, 0],
  withMargin: false
};
var Col = function Col(props) {
  return /*#__PURE__*/React__default.createElement(StyledCol, props);
};
Col.defaultProps = {
  'data-test-id': 'Col'
};

export { Col, Row };
//# sourceMappingURL=Grid.js.map
